export const YEAR = "year";
export const PDC_NO = "pdcNo";
export const PDC_AMOUNT = "pdcAmount";
export const PDC_DATE = "pdcDate";
export const PDC_REMARKS = "pdcRemarks";
export const PDC_CHECK = "pdcCheck";
